import { CSSProperties } from 'react';

export default function WhiteNarvarLogoShort({ s }: { s?: CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      style={{ verticalAlign: 'middle', ...s }}
    >
      <path
        d="M33.7677 19.9773C33.7677 24.4923 30.1153 28.1452 25.6008 28.1452H20.9049C20.3831 28.1452 19.9634 27.7255 19.9634 27.2036V19.9773C19.9634 17.2433 17.7402 15.0199 15.0066 15.0199C12.273 15.0199 10.0498 17.2433 10.0498 19.9773V27.2036C10.0498 27.7255 9.63009 28.1452 9.10832 28.1452H7.79255C7.27078 28.1452 6.85109 27.7255 6.85109 27.2036V19.9773C6.85109 15.4623 10.5035 11.8094 15.018 11.8094C19.5324 11.8094 23.1848 15.4623 23.1848 19.9773V24.9348H25.6008C28.3345 24.9348 30.5577 22.7113 30.5577 19.9773V12.751C30.5577 12.2292 30.9774 11.8094 31.4991 11.8094H32.8376C33.3594 11.8094 33.779 12.2292 33.779 12.751C33.779 12.7737 33.779 12.785 33.779 12.8077L33.7677 19.9773ZM19.9975 0C8.94952 0 0 8.95065 0 20C0 31.0493 8.94952 40 19.9975 40C31.0454 40 39.9949 31.0493 39.9949 20C39.9949 8.95065 31.0454 0 19.9975 0Z"
        fill="white"
      />
    </svg>
  );
}
